module.exports = __webpack_public_path__ + "static/media/coachTracker-Header-v2.5eae88c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coachTracker-Header-v2.svg
// module id = 708
// module chunks = 0